import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import WithRender from './page.tpl.html';
import config from './../../config';

import Header from '../layout/header';
import Footer from '../layout/footer';

@WithRender
@Component({
    components: {
        theader: Header,
        tfooter: Footer
    }
})
export default class Page extends Vue {

    site = config.Site

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/pages/page.ts